import store from "@/redux/store";

import React, { useState } from "react";
import { Navigate, useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { show } from '@/reducers/Modal'
import { alert, info,success, error } from '@/reducers/Modal'
import { addTenant, tenantoverview, tenantEdit, tenantNew, newTenant, authoriseDropBoxWithCode} from '@/reducers/Tenant'
import { TenantModel } from "@/models/Tenant";
import { TenantOverview } from "@/views/Tenant/TenantOverview";
import {Detail} from "@/views/Tenant/Detail";
import {TENANT} from "@/actions/globalConst";

import { open, close, setPos } from '@/reducers/Window'
import {WINDOW} from "@/actions/globalConst";


class TenantController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
    this.onSaveHandler = this.onSaveHandler.bind(this);
  }


   componentDidMount() {
       const { location, navigate } = this.props;
       
const params = new URLSearchParams(location.search);
const dropboxReturnCode = (params.get("code")); // is the number 123

        if(this.props?.selectedId && this.props?.selectedId != "" && (this.props.data.selected.key == "" || this.props?.selectedId != this.props.data.selected.key)) {
            store.dispatch( tenantEdit(this.props.selectedId));
            const dropboxReturnCode = (params.get("code")); // is the number 123
            if(dropboxReturnCode) {
//                store.dispatch( open({...WINDOW.DROPBOX_CONNECT, data: {type: "waiting"}} ) );
            }
            
        }else if(this.props?.view == "add" ) {
            store.dispatch( tenantNew());
        } else {
            if(history.state?.usr?.rolState) {
                //store.dispatch( cancel() );
            } else if(this.props?.data.apiState == TENANT.API_INIT) {
                store.dispatch( tenantoverview() );
            }
        }

        if(params.get("state") && params.get("code")) {
            const options = {
              pathname: location.pathname+'/edit/'+params.get("state"),
              search: '',
            };
            navigate(options, { replace: true });
            store.dispatch( authoriseDropBoxWithCode({tenantKey: params.get("state"), dropboxCode: params.get("code")}));
            store.dispatch( open({...WINDOW.DROPBOX_CONNECT, data: {type: "waiting"}} ) );
            
//            store.dispatch( tenantEdit(params.get("state")));

        }       
        
        
            
    let view = "";
        
   };

  
    onSaveHandler = async (data) => {
        const { dispatch } = this.props;

     try {
        await dispatch(addTenant(data)).then((retData) => {
            if(!retData.error) {
                this.props.navigate("../", {"replace": true});
            }
        })
        if(!this.props.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
       } 

      
    }
  
  render() {
    
      const {tenant, data} = this.props;
const params = new URLSearchParams(location.search);
const dropboxReturnCode = (params.get("code")); // is the number 123
const tenantKey = (params.get("state")); // is the number 123
    if(dropboxReturnCode && tenantKey && dropboxReturnCode != "" && tenantKey!= "") {
        return <Navigate to={location.pathname+"/edit/"+tenantKey} />


    }      
      
      if(this.props?.data.apiState == TENANT.API_READY) {
        if((this.props?.data?.view == TENANT.VIEW_DETAIL || location.pathname.endsWith("/add") ) ||  ((location.pathname.search("/edit") > 0) && this.props.data.selected.key != "" )) {
      return (
          <Detail {...this.props} key={this.props.changeKey} data={tenant} externTenants={data?.externTenants} changekey={this.props.changeKey} onSaveHandler={this.onSaveHandler} tenants={data.tenants} />
      );
        }

    return (
      <TenantOverview {...this.props}  onSaveHandler={this.onSaveHandler}/>
    );

      }      
  }
}
const TenantControllerrInit = (props) => {
    const { id } = useParams();
    const {selected} = props;
    const location = useLocation();
    const navigate = useNavigate();
    
const params = new URLSearchParams(location.search);
const dropboxReturnCode = (params.get("code")); // is the number 123
    if(params.get("state")) {
        const options = {
          pathname: location.pathname,
          search: '',
        };
        //navigate(options, { replace: true });
        //return;
        //store.dispatch( authoriseDropBoxWithCode({tenantKey: params.get("state"), dropboxCode: params.get("code")}));
        
        //return <Navigate to={options.pathname} />
        //store.dispatch( tenantEdit(params.get("state")));
    
    }       

  return (
    <TenantController 
      {...props} selectedId={id} location={location} navigate={navigate}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer, UserReducer, TenantReducer} = state;
    const {selected, settings} = TenantReducer
    const {key} = TenantReducer;
    const {user} = AuthReducer.user;
    const {error} = TenantReducer;
    
  return {
    user: user,
    error: error,
    changeKey: key,
    selected: selected,
    settings: settings,
    tenant: settings?.tenant,
    data: {...TenantReducer}
  };
}

export default connect(mapStateToProps)(TenantControllerrInit);  